import LoadingCardFragments from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/LoadingCardFragments/LoadingCardFragments";

export default LoadingCardFragments;
